import styled from 'foundations-theming/utils';
export const CommonStylesWrapper = styled.div.withConfig({
  displayName: "commonStyles__CommonStylesWrapper",
  componentId: "zv0udo-0"
})([".header-with-indent{font-weight:600;margin-bottom:16px !important;text-transform:uppercase;}"]);
export const AccordionItemWrapper = styled.div.withConfig({
  displayName: "commonStyles__AccordionItemWrapper",
  componentId: "zv0udo-1"
})(["padding:15px 20px;.accordion-item{margin:0;}.accordion-header{font-weight:600;text-transform:uppercase;}"]);
export const ExclusionsGroupWrapper = styled.div.withConfig({
  displayName: "commonStyles__ExclusionsGroupWrapper",
  componentId: "zv0udo-2"
})([".exclusion-group-header{font-weight:500;}.exclusion-group-input{width:33%;}"]);
export const UserFacingMessageAlertWrapper = styled.div.withConfig({
  displayName: "commonStyles__UserFacingMessageAlertWrapper",
  componentId: "zv0udo-3"
})([".text-without-indent > p{margin-bottom:0;}font-weight:bold;"]);